const defaults = () => ({
  podcastPrompt: '',
  preCannedQuestions: [],
  preCannedRails: [],
});

export default {
  namespaced: true,
  persist: ['podcastPrompt'],
  state: defaults,
  mutations: {
    HYDRATE(state, payload) {
      Object.assign(state, payload);
    },
    SET_PODCAST_PROMPT(state, value) {
      state.podcastPrompt = value;
    },
    RESET(state) {
      Object.assign(state, defaults());
    },
  },
};
